import * as z from "zod/v4";

export const addMobileUploadImage = {
  name: "addMobileUploadImage" as const,
  input: z.object({ token: z.string(), imageUrl: z.string() }),
  output: z.object({ success: z.boolean() }),
};
